import React, {useState, useEffect, useRef, useContext, useMemo, useCallback} from 'react';
/* TODO look at adding question rearranging in the Test, import the line below is a drag and drop library to try out. */
// import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import BreadcrumbAntd from "../../../common/BreadcrumbAntd";
import {Collapse, Divider, Form, Pagination, Select, Spin} from "antd";
import Button from "../../../common/Button";
import {
    Preview, Print,
    ChevronRightRounded, DeleteRounded,
    FileDownloadRounded,
    FitScreenRounded,
    PreviewRounded,
    PrintRounded,
    SaveRounded, SyncAltRounded,
    ViewColumnRounded
} from "@mui/icons-material";
import TestQuestionCard from "./components/TestQuestionCard";
import InputAntdInline from "../../../common/InputAntdInline";
import TableFilterControlsForm from "../../../common/TableFilterControlsForm";
import TableFilterControls from "../../../common/TableFilterControls";
import TableFilterControlsSection from "../../../common/TableFilterControlsSection";
import {useScreenMode} from "../../../common/context/ScreenModeContext";
import {BrandContext} from "../../../common/BrandContext";
import {useForm} from "antd/es/form/Form";
import Tabs from "../../../common/Tabs";
import Tab from "../../../common/Tab";
import axios from "../../../common/axios";
import {checkArrayVal, objectHasEntry, reIndexArray, swapItemsInArray} from "../../../common/utilityFunctions";
import ListAntD from "../../../common/ListAntD";
import {isCancel} from "axios";
import EmptyDataCard from "../../../common/EmptyDataCard";
import ExamFilters from "./components/ExamFilters";
import TestContentSelect from "./components/TestContentSelect";
import {useFormFilterBadge} from "../../../hooks/useFormFilterBadge";
import TestFilters from "./components/TestFilters";
import DiagnosticTestContentSelect, {DiagnosticTabType} from "./components/DiagnosticTestContentSelect";
import DiagnosticTestFilters from "./components/DiagnosticTestFilters";
import {
    searchTestQuestionsPaged,
    getAndSetTestData,
    getAndSetTestQuestionData,
    saveDescription,
    saveName,
    saveTestData
} from "./axiosRequests/axiosRequests";
import {SELECT_LEVELS} from "../../../common/SyllabusTopicConceptSelect";
import Tooltip from "../../../common/Tooltip";
import PreviewTestDialog from "../PreviewTestDialog";

const ContentTabs = {
    Text: {val: '0', display: 'Text', hash: 'text', selectKey: 'text-tab-select'},
    Curriculum: {val: '1', display: 'Curriculum', hash: 'curriculum', selectKey: 'curriculum-tab-select'}
}
const DEFAULT_PAGE_SIZE = 5;

const TestEdit = ({
                      // testId = 749778 //Diagnostic test data
                      testId = 886513 //Assessment test data
                      // testId = 876362 // Exam - Online test data
                      // testId = 874620 // Exam - PDF test data
}) => {
    const [title, setTitle] = useState(''),
        [description, setDescription] = useState(''),
        [assessmentType, setAssessmentType] = useState(''),
        contentPanelsRef = useRef(null),
        [questionFiltersSearchForm] = useForm(),
        {mobileScreenMode} = useScreenMode(),
        brandConfig = useContext(BrandContext),
        [testData, setTestData] = useState({}),
        [useSections, setUseSections] = useState(false), //sections are used for Exam - PDFs Test type
        [sectionsInit, setSectionsInit] = useState(false),
        [isPreviewDialogOpen, setPreviewDialogOpen] = useState(false),
        [sectionTabs, setSectionTabs] = useState([]),
        [sectionsObj, setSectionsObj] = useState(null),
        [selectedQuestionsSection, setSelectedQuestionsSection] = useState([]),
        [contentTabVal, setContentTabVal] = useState('0'),
        [sectionTabVal, setSectionTabVal] = useState(null),
        [searchTestQuestionsParams, setSearchTestQuestionsParams] = useState({}),
        [testQuestionData, setTestQuestionData] = useState([]),
        [pagedTestQuestionData, setPagedTestQuestionData] = useState([]),
        // [questionBankQuestions, setQuestionBankQuestions] = useState([]),
        [selectedQuestionIds, setSelectedQuestionIds] = useState([]),
        [questionBankTotal, setQuestionBankTotal] = useState(0),
        {
            activeFilterCount,
            onLoadComplete,
            handleValuesChange: handleBadgeValuesChange
        } = useFormFilterBadge(questionFiltersSearchForm),
        syllabusId = Form.useWatch('syllabusId', questionFiltersSearchForm),
        [currentPage, setCurrentPage] = useState(1),
        [initTestLoading, setInitTestLoading] = useState(true),
        [saveTestLoading, setSaveTestLoading] = useState(false),
        [saveTestNameLoading, setSaveTestNameLoading] = useState(false),
        [saveTestDescriptionLoading, setSaveTestDescriptionLoading] = useState(false),
        [filterOpen, setFilterOpen] = useState(false);

    const handleSaveTest = () => {
        setSaveTestLoading(true);
        const callback = () => {
            const updateData = testQuestionData.length > 0 ? reIndexArray([...testQuestionData], 'questionSeq') : [];
            setTestQuestionData(updateData);
            setSaveTestLoading(false);
        }
        saveTestData({
            callback: callback,
            body: {...changeDataForSave(testQuestionData)},
            params: {testId: testData.testId}
        });
    }
    const changeDataForSave = (questionData) => {
        const questionIds = [],
            conceptIds = [];
        questionData.forEach((question) => {
            questionIds.push(question.questionId);
            conceptIds.push(question.concept?.conceptId);
        })
        return {questionIds: questionIds, conceptIds: conceptIds};
    }

    const handlePrintTest = () => {
        printTestWithColumn(1, testId);
    }

    const handlePreviewTest = () => {
        setPreviewDialogOpen(true);
    }

    const toggleFilterOpen = () => {
        setFilterOpen(prevState => !prevState);
    }

    const handleSaveName = (val) => {
        if (val !== title) {
            setSaveTestNameLoading(true);
            const callback = () => {
                setSaveTestNameLoading(false);
            }
            saveName({testId: testId, name: val}, callback);
        }
    }

    const handleSaveDescription = (val) => {
        if (val !== description) {
            setSaveTestDescriptionLoading(true);
            const callback = () => {
                setSaveTestDescriptionLoading(false);
            }
            saveDescription({testId: testId, description: val}, callback);
        }
    }

    const addQuestionToTest = (questionData) => {
        const updateQuestion = {...questionData};
        const updateObj = {...sectionsObj};
        updateQuestion.questionSeq = undefined;
        if (useSections) {
            // if section tab is there add question to it, otherwise add section
            if (updateObj.hasOwnProperty(updateQuestion.section)) {
                if (updateObj[updateQuestion.section].hasOwnProperty('questions')) {
                    updateObj[updateQuestion.section].questions.push(updateQuestion);
                } else {
                    updateObj[updateQuestion.section].questions = [updateQuestion];
                }
            } else {
                updateObj[updateQuestion.section] = {questions: [updateQuestion]};
            }
            setSectionsObj({...updateObj});
            setSectionTabVal(updateQuestion.section);
        } else {
            updateQuestion.index = testQuestionData.length;
        }
        setTestQuestionData([...testQuestionData, updateQuestion]);
    }

    const searchTestQuestions = () => {
        setSearchTestQuestionsParams(getTestQuestionsParams());
        handleBadgeValuesChange();
    }

    const getTestQuestionsParams = () => {
        let testParams = {...questionFiltersSearchForm.getFieldsValue()};

        if (testParams.testDifficultyLevel === undefined || testParams.testDifficultyLevel === 'All') {
            //remove param so it searches all difficulties
            delete testParams.testDifficultyLevel;
        }
        if (testParams.conceptId === 0) {
            testParams.conceptId = null;
        }
        if (testParams.topicId === 0) {
            testParams.topicId = null;
        }
        if (testParams.syllabusId === 0) {
            testParams.syllabusId = null;
        }
        if (testParams.syllabusGroupId === 0) {
            testParams.syllabusGroupId = null;
        }
        if (testParams.examStyle === 'All') {
            delete testParams.examStyle;
        }
        if (testParams.section === 'All') {
            delete testParams.section;
        }
        if (testParams.examYear === 'All') {
            delete testParams.examYear;
        }
        if (testParams.examNumber === 'All') {
            delete testParams.examNumber;
        }
        if (testParams.testDifficultyLevel === 'All') {
            delete testParams.testDifficultyLevel;
        }
        if (testParams.useCalculator === 'All') {
            delete testParams.useCalculator;
        } else if (testParams.hasOwnProperty('useCalculator')) {
            testParams.useCalculator = testParams.useCalculator.toLowerCase() === 'true';
        }
        if (testParams.questionAnswerTypeGroup === 'All') {
            delete testParams.questionAnswerTypeGroup;
        }
        // if(testData.exam){
        //     testParams.testPurpose = 'EXAM';
        // }
        // if(testData.diagnosticTest){
        //     testParams.testPurpose = 'DIAGNOSTIC_TEST';
        // }
        testParams.testPurpose = testData.testPurpose;

        if (testParams.hasOwnProperty('filterCategory')) {
            if (testParams.filterCategory.includes('exclusive-to-tests')) {
                testParams.digitalOnly = true;
            }
            delete testParams.filterCategory;
        }

        if (testData.skillCode === 'All') {
            delete testData.skillCode;
        }

        return testParams;
    }

    const removeQuestionFromTest = (testQuestion) => {
        const updatedQuestions = testQuestionData.filter(question => question.questionId !== testQuestion.questionId);
        setTestQuestionData(updatedQuestions);
        let newTotalPages;
        if (useSections) {
            const updateSectionsObj = {...sectionsObj};
            if (updateSectionsObj[sectionTabVal].questions.length === 1) {
                delete updateSectionsObj[sectionTabVal];
                if (Object.keys(updateSectionsObj).length > 0) {
                    const keyIndex = 0;
                    newTotalPages = Math.ceil(updateSectionsObj[Object.keys(updateSectionsObj)[keyIndex]].questions.length / DEFAULT_PAGE_SIZE);
                } else {
                    newTotalPages = 0;
                }
                setSectionTabVal(null);
            } else {
                const sectionQuestions = updateSectionsObj[sectionTabVal].questions.filter(question => question.questionId !== testQuestion.questionId);
                updateSectionsObj[sectionTabVal].questions = [...sectionQuestions];
                setSelectedQuestionsSection([...sectionQuestions])
            }
            setSectionsObj({...updateSectionsObj});
        } else {
            newTotalPages = Math.ceil(updatedQuestions.length / DEFAULT_PAGE_SIZE);
        }

        if (currentPage > newTotalPages) {
            setCurrentPage(newTotalPages);
        }
    };

    const handleEditTestQuestion = (questionId) => {
        // console.log('handleEditTestQuestion questionId: ',questionId);
        /* TODO add handle edtTestQuestion for Admin*/
    }

    const handleMoveQuestion = (index1, index2) => {
        if (useSections) {
            setSelectedQuestionsSection(reIndexArray(swapItemsInArray(selectedQuestionsSection, index1, index2)));
        } else {
            setTestQuestionData(reIndexArray(swapItemsInArray(testQuestionData, index1, index2)));
        }
    }

    const addAllOnPageToTest = () => {
        /* TODO add all on selected page from question bank tot test */
        console.log('addAllOnPageToTest');
    }

    const removeSelectedAllOnPageFromTest = () => {
        /* TODO remove selected checkbox test Questions from test Selected Questions */
        console.log('removeAllOnPageFromTest');
    }

    useEffect(() => {
        getAndSetTestData(testId).then((data) => {
            setTestData(data);
        });
    }, [testId]);

    useEffect(() => {
        // console.log('testData: ',testData);
        if (objectHasEntry(testData)) {
            setTitle(testData.name);
            setDescription(testData.description);
            setAssessmentType(testData.exam ? 'Exam - ' + (testData.autoMark ? 'online' : 'PDF') : (testData.diagnosticTest ? 'Diagnostic ' : '') + 'Test')
            setUseSections(testData.exam && !testData.autoMark);
            getAndSetTestQuestionData(testId).then((data) => {
                setTestQuestionData(data);
            }).finally(() => {
                setInitTestLoading(false);
            });
        }
    }, [testData])

    useEffect(() => {
        if (useSections) {
            if (sectionsInit) {
                // console.log('selectedQuestionsSection: ',selectedQuestionsSection);
                if (selectedQuestionsSection.length === 0) {
                    setPagedTestQuestionData([]);
                } else {
                    const startIndex = (currentPage - 1) * DEFAULT_PAGE_SIZE,
                        endIndex = startIndex + DEFAULT_PAGE_SIZE;
                    setPagedTestQuestionData(selectedQuestionsSection.slice(startIndex, endIndex));
                }
            } else {
                if (testQuestionData.length > 0) {
                    const sectionObj = {};
                    testQuestionData.forEach((testQuestion) => {
                        // console.log('testQuestion: ',testQuestion);
                        const sectionVal = testQuestion.section;
                        if (!sectionObj.hasOwnProperty(sectionVal)) {
                            sectionObj[sectionVal] = {name: sectionVal, hash: sectionVal, questions: [testQuestion]}
                        } else {
                            sectionObj[sectionVal].questions.push(testQuestion);
                        }
                    });
                    setSectionsObj(sectionObj);
                } else {
                    setSectionsObj({});
                }
                setSectionsInit(true);
            }
        } else {
            if (testQuestionData.length === 0) {
                setPagedTestQuestionData([]);
            } else {
                const startIndex = (currentPage - 1) * DEFAULT_PAGE_SIZE,
                    endIndex = startIndex + DEFAULT_PAGE_SIZE;
                setPagedTestQuestionData(testQuestionData.slice(startIndex, endIndex))
            }
        }
    }, [currentPage, testQuestionData]);

    useEffect(() => {
        setSelectedQuestionIds(testQuestionData.map(question => question.questionId));
    }, [testQuestionData]);

    useEffect(() => {
        if (sectionsObj !== null) {
            if (sectionTabVal === null && objectHasEntry(sectionsObj)) {
                // set to first section tab.
                // console.log('Object.keys(sectionsObj)[0]: ',Object.keys(sectionsObj)[0]);
                setSectionTabVal(Object.keys(sectionsObj)[0]);
            }
            setSectionTabs(Object.entries(sectionsObj).map(([key, value]) => {
                return {key: key, label: key, total: value.questions ? value.questions.length + '' : '0'}
            }));
        }
    }, [sectionsObj]);

    useEffect(() => {
        // console.log('sectionTabVal: ',sectionTabVal);
        if (sectionTabVal !== null && sectionsObj.hasOwnProperty(sectionTabVal)
            && sectionsObj[sectionTabVal].hasOwnProperty('questions')
        ) {
            setSelectedQuestionsSection(sectionsObj[sectionTabVal].questions);
        } else {
            setSelectedQuestionsSection([]);
        }
    }, [sectionTabVal])

    const renderQuestionBankPanel = useMemo(() => {
        const TestQuestionCardInBank = (question, index, value) => {
            // console.log('question: ',question);
            // console.log('value: ',value);
            const propsForQuestionBankQuestion = {
                ...question, initialIndex: index,
                test: {exam: testData.exam, diagnosticTest: testData.diagnosticTest},
                key: question.questionId, editTestQuestion: handleEditTestQuestion, inQuestionBank: true,
                onAdd: () => {
                    addQuestionToTest(question)
                }
            };
            if (selectedQuestionIds.includes(question.questionId)) {
                propsForQuestionBankQuestion.selectedForTest = true;
            }
            return <TestQuestionCard {...propsForQuestionBankQuestion} />
        }
        return (
            <div className={mobileScreenMode ? 'ch-test-editor-content-panel-ac' : 'ch-test-editor-content-panel'}>
                {!mobileScreenMode &&
                    <div>
                        <div className={'ch-test-editor-content-panel-heading'}>
                            <h3>Question Bank</h3>
                            <div className={'ch-test-editor-content-button-wrapper'}>
                                <Tooltip title={'Expand all questions'}>
                                    <Button type={'text'}>
                                        <ChevronRightRounded
                                            style={{transform: 'rotate(90deg)', transition: 'var(--ani-mid) ease'}}/>
                                    </Button>
                                </Tooltip>
                                <Tooltip title={'Full width view'}>
                                    <Button type={'text'}><FitScreenRounded/></Button>
                                </Tooltip>
                            </div>
                        </div>
                        <Divider className={'ch-divider'}/>
                    </div>
                }
                <div className={'ch-test-editor-search-results'}>
                    <ListAntD id="testAssignmentsFollowUp" showBackgroundOnHover={false} removeListPadding={true}
                              pagingDependencies={[searchTestQuestionsParams]} pagingData={{
                        fetchFunction: searchTestQuestionsPaged,
                        params: {...searchTestQuestionsParams, pageSize: 5}
                    }}
                        // reload={triggerReload}
                              noDataMessage={<EmptyDataCard message={'No results found, try changing your search.'}/>}
                              position={'bottom'}
                              renderItem={(question, index, value) => (
                                  TestQuestionCardInBank(question, index, value)
                              )}/>

                </div>
            </div>
        )
    }, [searchTestQuestionsParams, selectedQuestionIds]);

    const handlePageChange = useCallback((pageNumber) => {
        // console.log('pageNumber: ',pageNumber);
        setCurrentPage(pageNumber);
    }, []);

    const renderSelectedQuestionsPagination = useMemo(() => {
        if (useSections) {
            return <>{selectedQuestionsSection.length > 0 &&
                <Pagination style={{margin: 0}} onChange={handlePageChange} current={currentPage}
                            pageSize={DEFAULT_PAGE_SIZE} defaultCurrent={1}
                            total={selectedQuestionsSection.length}/>}</>
        } else {
            return <>{testQuestionData.length > 0 &&
                <Pagination style={{margin: 0}} onChange={handlePageChange} current={currentPage}
                            pageSize={DEFAULT_PAGE_SIZE} defaultCurrent={1} total={testQuestionData.length}/>}</>
        }
    }, [currentPage, testQuestionData.length, selectedQuestionsSection.length]);

    const onSectionTabChange = (val) => {
        if (sectionsInit && selectedQuestionsSection.length > 0) {
            const updateSectionsObj = {...sectionsObj};
            updateSectionsObj[sectionTabVal].questions = [...selectedQuestionsSection];
            setSectionsObj({...updateSectionsObj});
        }
        setSectionTabVal(val);
        if (sectionsObj.hasOwnProperty(val)) {
            const questions = checkArrayVal(sectionsObj[val].questions);
            setSelectedQuestionsSection(questions);
            // setCurrentPage((Math.ceil(questions.length/DEFAULT_PAGE_SIZE)));
            setCurrentPage(1);
        }
    }


    useEffect(() => {
        if (selectedQuestionsSection.length === 0) {
            setPagedTestQuestionData([]);
        } else {
            const startIndex = (currentPage - 1) * DEFAULT_PAGE_SIZE,
                endIndex = startIndex + DEFAULT_PAGE_SIZE;
            setPagedTestQuestionData(selectedQuestionsSection.slice(startIndex, endIndex));
        }
    }, [selectedQuestionsSection]);

    const renderSelectedQuestionsPanel = useMemo(() => {
        return (
            <div className={mobileScreenMode ? 'ch-test-editor-content-panel-ac' : 'ch-test-editor-content-panel'}>
                {!mobileScreenMode &&
                    <div>
                        <div className={'ch-test-editor-content-panel-heading'}>
                            <h3>Selected Questions ({selectedQuestionIds.length})</h3>
                            <div className={'ch-test-editor-content-button-wrapper'}>
                                <Tooltip title={'Move questions to another page'}>
                                    <Button type={'text'}><SyncAltRounded/></Button>
                                </Tooltip>
                                <Tooltip title={'Remove selected questions'}>
                                    <Button type={'text'}><DeleteRounded/></Button>
                                </Tooltip>
                                <Tooltip title={'Expand all questions'}>
                                    <Button type={'text'}>
                                        <ChevronRightRounded
                                            style={{transform: 'rotate(90deg)', transition: 'var(--ani-mid) ease'}}/>
                                    </Button>
                                </Tooltip>
                                <Tooltip title={'Show column view'}>
                                    <Button type={'text'}><ViewColumnRounded/></Button>
                                </Tooltip>
                                <Tooltip title={'Full width view'}>
                                    <Button type={'text'}><FitScreenRounded/></Button>
                                </Tooltip>
                            </div>
                        </div>
                        <Divider className={'ch-divider'}/>
                        {/*renderSelectedQuestionsPagination()*/}
                    </div>}
                {!initTestLoading && <>
                    {(useSections && sectionTabs.length > 0) &&
                        <Tabs onChange={onSectionTabChange} activeKey={sectionTabVal}>
                            {sectionTabs.map((tab) => {
                                return <Tab key={tab.key} tab={'Section ' + tab.label + ' (' + tab.total + ')'}
                                            hash={tab.key}/>
                            })}
                        </Tabs>
                    }
                    <div className={'ch-test-editor-search-results'}>
                        {pagedTestQuestionData.length > 0 && pagedTestQuestionData.map((testQuestion) => {
                            // console.log('testQuestion: ',testQuestion);
                            return <TestQuestionCard initialIndex={testQuestion.questionSeq}
                                                     index={testQuestion.questionSeq} key={testQuestion.questionId}
                                                     questionTotal={useSections ? selectedQuestionsSection.length : testQuestionData.length} {...testQuestion}
                                                     onRemove={() => {
                                                         removeQuestionFromTest(testQuestion)
                                                     }} onMoveQuestion={handleMoveQuestion}
                                                     editTestQuestion={handleEditTestQuestion}
                                                     test={{
                                                         exam: testData.exam,
                                                         diagnosticTest: testData.diagnosticTest
                                                     }}
                                                     selectedForTest={true} inQuestionBank={false}/>
                        })}
                        {(testQuestionData.length === 0) && <EmptyDataCard
                            message={"Add questions to " + brandConfig.testName + " from the 'Question Bank'"}/>}
                    </div>
                    <div className={'flexJustifyEnd'}>{renderSelectedQuestionsPagination}</div>
                </>}
                {initTestLoading &&
                    <div style={{marginTop: '25px'}} className={'flexCentre'}><Spin size={"large"}/></div>}
            </div>
        )
    }, [initTestLoading, pagedTestQuestionData, testQuestionData, sectionTabs])

    const collapsePanels = useMemo(() => {
        return [
            {
                key: '1',
                showArrow: false,
                label: <div className={'flexSpaceBetween flexAlignCentre'}><h3>Question Bank
                    ({questionBankTotal})</h3>renderSelectedQuestionsPagination</div>,
                children: renderQuestionBankPanel
            },
            {
                key: '2',
                showArrow: false,
                label: <h3>Selected Questions ({selectedQuestionIds.length})</h3>,
                children: renderSelectedQuestionsPanel
            },
        ];
    }, [selectedQuestionIds, questionBankTotal]);

    const ContentSelect = useMemo(() => {
        // console.log('testData.exam: ',testData.exam);
        return <TestContentSelect onChange={searchTestQuestions} axiosProps={{forExams: testData.exam}}
                                  defaultLevel={SELECT_LEVELS.SYLLABUS} form={questionFiltersSearchForm}
                                  popupMatchSelectWidth={false}/>
    }, [testData]);

    const onTabChange = (value) => {
        if (value) {
            setContentTabVal(value);
            questionFiltersSearchForm.resetFields();
        }
    }

    // Zach you can leave the breadcrumb and routing until I get back if you want
    // else you can copy from the new schoolManagement/schoolManagement.js using Wouter
    // Usually we will show this page without the tab bar at the top
    return (
        <>
            <div>
                {initTestLoading &&
                    <div className={'flexCentre padding-t--l padding-b--l'}><Spin tip="Loading Editor..." size="large">
                        <div style={{
                            width: '100%',
                            height: '100%',
                            padding: '100px 200px',
                            borderRadius: '10px',
                            border: '1px solid #ccc'
                        }}></div>
                    </Spin></div>}
                {!initTestLoading && <div className={'ch-test-editor'} style={{minHeight: '1200px'}}>
                    <BreadcrumbAntd
                        breadcrumbs={[{label: 'Assessments'}, {label: 'My Assessments'}, {label: 'Edit Assessment'}]}/>
                    <div className={'ch-test-editor-sticky-title'}> {/* From Change 2 */}
                        <div className={'ch-test-editor-heading-wrapper'}>
                            <div className={'ch-test-editor-heading'}>
                                <InputAntdInline placeholder={'name'} isLoading={saveTestNameLoading} onSave={(val) => {
                                    handleSaveName(val);
                                    setTitle(val);
                                }} value={title}/>
                                <InputAntdInline placeholder={'description'} isLoading={saveTestDescriptionLoading}
                                                 onSave={(val) => {
                                                     handleSaveDescription(val);
                                                     setDescription(val);
                                                 }} value={description} textType={'p'}
                                                 className={'ch-test-editor-description'}/>
                            </div>
                            <div
                                className={'ch-test-editor-button-wrapper'}>
                                <Button
                                    type={'outline'}
                                    icon={<PreviewRounded/>}
                                    onClick={handlePreviewTest}
                                >
                                    Preview
                                </Button>
                                <Button
                                    type={'outline'}
                                    icon={<PrintRounded/>}
                                    onClick={handlePrintTest}
                                >
                                    Print
                                </Button>
                                {useSections && <Button
                                    type={'outline'}
                                    icon={<FileDownloadRounded/>}
                                >
                                    Word Doc
                                </Button>}
                                <Button
                                    icon={<SaveRounded/>}
                                    onClick={handleSaveTest}
                                    loading={saveTestLoading}
                                >
                                    Save
                                </Button>
                            </div>
                        </div>
                        <Divider className={'ch-divider'}/> {/* Divider moved inside the sticky-title div */}
                    </div>
                    {objectHasEntry(testData) &&
                        <TableFilterControls
                            // filterCount={activeFilterCount}
                            // showFilterButton={true}
                            // showFilterIcon={false}
                            // filterButtonHeading={'Content'}
                            primaryFilterItem={testData.diagnosticTest && (
                                <Form.Item label={'Search questions by:'}>
                                    <Select
                                        value={contentTabVal}
                                        onChange={onTabChange}
                                        options={[
                                            {label: ContentTabs.Text.display, value: ContentTabs.Text.val},
                                            {label: ContentTabs.Curriculum.display, value: ContentTabs.Curriculum.val}
                                        ]}
                                        style={{minWidth: 200}}
                                    />
                                </Form.Item>
                            )}
                            filterContent={
                                <TableFilterControlsForm
                                    initialValues={{
                                        excludeTestOnly: false,
                                        topicId: 0,
                                        conceptId: 0,
                                        skillCode: 0,
                                        ...(testData.exam ? {
                                            examStyle: 'All',
                                            examYear: 'All',
                                            examNumber: 'All',
                                            section: 'All',
                                            testDifficultyLevel: 'All',
                                            useCalculator: 'All',
                                            questionAnswerTypeGroup: testData.autoMark ? 'MULTIPLE_CHOICE' : 'All'
                                        } : testData.diagnosticTest ? {
                                            testDifficultyLevel: 'All',
                                            skillKeyword: ''
                                        } : {
                                            testDifficultyLevel: 'All',
                                            digitalOnly: true
                                        })
                                    }}
                                    form={questionFiltersSearchForm}
                                    additionalFilterSections={(() => {
                                        if (testData.exam) {
                                            return [<ExamFilters key="exam-filters" onLoadComplete={onLoadComplete}
                                                                 onUpdate={searchTestQuestions}
                                                                 isAutoMark={testData.autoMark}
                                                                 syllabusId={syllabusId}/>];
                                        }
                                        if (testData.diagnosticTest) {
                                            return [<DiagnosticTestFilters key="diagnostic-filters"
                                                                           onLoadComplete={onLoadComplete}
                                                                           onUpdate={searchTestQuestions}/>];
                                        }
                                        return [<TestFilters key="test-filters" onLoadComplete={onLoadComplete}
                                                             onUpdate={searchTestQuestions}/>];
                                    })()}
                                >
                                    {/*<Button onClick={searchTestQuestions} icon={<SearchIcon/>}>Search</Button>*/}
                                    {!testData.diagnosticTest &&
                                        <TableFilterControlsSection showDivider={false}>
                                            {ContentSelect}
                                        </TableFilterControlsSection>
                                    }
                                    {testData.diagnosticTest &&
                                        <TableFilterControlsSection showDivider={false}>
                                            <DiagnosticTestContentSelect
                                                key={contentTabVal === ContentTabs.Text.val ? ContentTabs.Text.selectKey : ContentTabs.Curriculum.selectKey}
                                                onChange={searchTestQuestions}
                                                form={questionFiltersSearchForm}
                                                diagnosticTabType={contentTabVal === ContentTabs.Text.val ? DiagnosticTabType.TEXT : DiagnosticTabType.CURRICULUM}
                                            />
                                        </TableFilterControlsSection>
                                    }
                                </TableFilterControlsForm>
                            }/>}
                    <div className={'ch-test-editor-content-panels margin-t--l'}
                         ref={contentPanelsRef}> {/* Retaining margin-t--l from Change 1 */}
                        {!mobileScreenMode &&
                            <>
                                {renderQuestionBankPanel}
                                {renderSelectedQuestionsPanel}
                            </>
                        }
                        {mobileScreenMode &&
                            <Collapse
                                // collapsible={"disabled"}
                                defaultActiveKey={['1']}
                                items={collapsePanels}
                                ghost
                                style={{width: '100%'}}
                            />
                        }
                    </div>
                </div>}
            </div>
            <PreviewTestDialog title={'Preview ' + title}
                   open={isPreviewDialogOpen}
                   onClose={() => setPreviewDialogOpen(false)}
                   testId={testId}
            />
        </>
    );
}
export default TestEdit;